var majVer = 7;
var minVer = 2;
var magics = [45, 128, 231];
Math.trunc = Math.trunc || function (x) {
    if (isNaN(x)) {
        return NaN;
    }
    if (x > 0) {
        return Math.floor(x);
    }
    return Math.ceil(x);
};
export var lcv = {
    __kt: 0,
    ck: function (key) {
        if (!key || !key.length) {
            this.__kt = -3;
            return;
        }
        try {
            var part1 = key.slice(0, key.length - 12);
            var infoBytes = _bs(part1);
            var part2 = key.slice(key.length - 12);
            var ism = false;
            for (var _i = 0, magics_1 = magics; _i < magics_1.length; _i++) {
                var magic = magics_1[_i];
                var edc = t36(magic);
                if (part2[0] === edc[0] && part2[2] === edc[1]) {
                    ism = true;
                    break;
                }
            }
            if (!ism) {
                lcv.__kt = -1;
            }
            var idx = minVer % 4;
            var shift = majVer + minVer;
            if (part2[6 + idx] != encChar(shift, 19)) {
                lcv.__kt = -2;
                return;
            }
            if (part2[1] != encChar(infoBytes[3])) {
                return;
            }
            lcv.__kt = part2[3] != encChar(infoBytes[5]) ? 2 : 3;
            if (lcv.__kt === 2) {
                var eds = "" + f36(part2.substring(4, 6) + part2.substring(10));
                var ed = new Date(2000 + Number.parseInt(eds.substring(0, 2)), Number.parseInt(eds.substring(2, 4)) - 1, Number.parseInt(eds.substring(4)), 0, 0, 0, 0);
                if (Date.now() > ed.getTime()) {
                    lcv.__kt = 1;
                }
            }
        }
        catch (error) {
        }
    }
};
function encChar(x, b) {
    if (b === void 0) { b = 20; }
    return String.fromCharCode(65 + x % b);
}
function _bs(str) {
    var binary_string = urlatob(str);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
}
function urlatob(str) {
    var s = str;
    s = s.replace(/-/g, '+');
    s = s.replace(/_/g, '/');
    switch (s.length % 4) {
        case 0:
            break;
        case 2:
            s += "==";
            break;
        case 3:
            s += "=";
            break;
    }
    return window.atob(s);
}
var tokens = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
function t36(val) {
    var result = "";
    while (val > 0) {
        result = tokens[val % tokens.length] + result;
        val /= tokens.length;
    }
    return result;
}
function f36(val) {
    var d = 0;
    for (var i = 0; i < val.length; ++i)
        d += tokens.indexOf(val[i]) * Math.pow(tokens.length, val.length - i - 1);
    return d;
}
//# sourceMappingURL=lcv.js.map